import styled from 'styled-components'

export const FormWindow = styled.form`
  max-width: 500px;
  margin: 0 auto;
  background-color: #ffffffcc; /* lekko przezroczysty biały */
  padding: 30px;
  border-radius: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  font-family: 'Segoe UI', sans-serif;
`

export const Tittle = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: rgb(60, 105, 112);
  text-align: center;
  margin-bottom: 1rem;
  position: relative;

  &after: {
    content: '';
    display: block;
    width: 60px;
    height: 4px;
    background-color: rgb(60, 105, 112);
    margin: 10px auto 0;
    border-radius: 2px;
  }
`
export const FormInput = styled.input`
  padding: 12px 16px;
  border: 1px solid #a3c8d0;
  border-radius: 10px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s ease-in-out;

  &focus: {
    border-color: rgb(60, 105, 112);
    box-shadow: 0 0 0 2px rgba(60, 105, 112, 0.1);
  }
`

export const FormTextarea = styled.textarea`
  padding: 12px 16px;
  border: 1px solid #a3c8d0;
  border-radius: 10px;
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s ease-in-out;
  resize: vertical;
  min-height: 100px;

  &focus: {
    order-color: rgb(60, 105, 112);
    box-shadow: 0 0 0 2px rgba(60, 105, 112, 0.1);
  }
`

export const FormButton = styled.button`
  background-color: rgb(104, 157, 165);
  color: white;
  padding: 12px 20px;
  font-size: 1rem;
  font-weight: bold;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: rgb(82, 128, 136);
  }
`
